var map = {
	"./components/toast/fail.png": 1374,
	"./components/toast/succeed.png": 272,
	"./components/toast/warn.png": 3957,
	"./pc/icon.png": 2201,
	"./pc/match/1.jpg": 7307,
	"./pc/match/11.png": 4466,
	"./pc/match/12.png": 1012,
	"./pc/match/12a.png": 1323,
	"./pc/match/13.png": 1182,
	"./pc/match/13a.png": 3594,
	"./pc/match/14.png": 4509,
	"./pc/match/15.png": 9684,
	"./pc/match/16.png": 7955,
	"./pc/match/17.png": 5234,
	"./pc/match/18.png": 7089,
	"./pc/match/19.png": 2123,
	"./pc/match/2.png": 7801,
	"./pc/match/20.png": 8335,
	"./pc/match/21.png": 4393,
	"./pc/match/22a.png": 4471,
	"./pc/match/23a.png": 3978,
	"./pc/match/24a.png": 5262,
	"./pc/match/25a.png": 1221,
	"./pc/match/26a.png": 9232,
	"./pc/match/27.png": 4887,
	"./pc/match/27a.png": 5745,
	"./pc/match/28.png": 8382,
	"./pc/match/29.png": 6159,
	"./pc/match/29a.png": 201,
	"./pc/match/30.png": 593,
	"./pc/match/30a.png": 2633,
	"./pc/match/31.png": 7954,
	"./pc/match/31a.png": 2936,
	"./pc/match/32.png": 2878,
	"./pc/match/32a.png": 9796,
	"./pc/match/33.png": 9822,
	"./pc/match/33a.png": 8690,
	"./pc/match/34.png": 2370,
	"./pc/match/34a.png": 1769,
	"./pc/match/35.png": 1560,
	"./pc/match/35a.png": 768,
	"./pc/match/36.png": 6240,
	"./pc/match/36a.png": 9065,
	"./pc/match/37.png": 8433,
	"./pc/match/37a.png": 213,
	"./pc/match/38.png": 2858,
	"./pc/match/38a.png": 1418,
	"./pc/match/39.png": 7821,
	"./pc/match/39a.png": 21,
	"./pc/match/4.png": 7503,
	"./pc/match/40.png": 9746,
	"./pc/match/40a.png": 971,
	"./pc/match/41.png": 8963,
	"./pc/match/41a.png": 7233,
	"./pc/match/42.png": 2785,
	"./pc/match/42a.png": 5349,
	"./pc/match/43a.png": 3054,
	"./pc/match/44a.png": 5125,
	"./pc/match/5.png": 9080,
	"./pc/match/6.jpg": 4214,
	"./pc/match/7.png": 5885,
	"./pc/match/8.png": 8789,
	"./pc/match/8a.png": 5074,
	"./pc/match/9.png": 175,
	"./pc/match/9a.png": 8025,
	"./pc/match/Maskgroup.png": 1149,
	"./pc/match/back-home-button.png": 5630,
	"./pc/match/cta-go.png": 9574,
	"./pc/match/detail-rules-battle-label.png": 6264,
	"./pc/match/detail-rules-bg.png": 7467,
	"./pc/match/detail-rules-character.png": 144,
	"./pc/match/detail-rules-signup-label.png": 5319,
	"./pc/match/detail-rules-title.png": 2540,
	"./pc/match/detail-schedule-bg.png": 9931,
	"./pc/match/detail-schedule-timeline.png": 7187,
	"./pc/match/detail-schedule-title.png": 1912,
	"./pc/match/dy.png": 7922,
	"./pc/match/dy2.png": 8918,
	"./pc/match/follow-title.png": 4365,
	"./pc/match/gzh.jpg": 4685,
	"./pc/match/hero-bg.png": 5792,
	"./pc/match/hover (1).png": 2990,
	"./pc/match/hover.png": 8346,
	"./pc/match/mobile-home-follow-bg.jpg": 2629,
	"./pc/match/mobile-home-footer-bg.jpg": 3626,
	"./pc/match/mobile-home-hero-bg.jpg": 5326,
	"./pc/match/mobile-home-news-bg.jpg": 3201,
	"./pc/match/mobile-home-progress-bg.jpg": 5492,
	"./pc/match/mobile-home-video-bg.jpg": 6718,
	"./pc/match/nav-bg.png": 954,
	"./pc/match/news-frame.png": 7989,
	"./pc/match/news-section-bg.png": 5210,
	"./pc/match/news-title.png": 8442,
	"./pc/match/play.png": 2605,
	"./pc/match/progress-battle-map.png": 6379,
	"./pc/match/progress-card-left-bottom.png": 8408,
	"./pc/match/progress-card-left-top.png": 2544,
	"./pc/match/progress-card-right-bottom.png": 3611,
	"./pc/match/progress-card-right-top.png": 2496,
	"./pc/match/progress-frame.png": 8142,
	"./pc/match/progress-mask.png": 3215,
	"./pc/match/progress-red-sun.png": 297,
	"./pc/match/progress-section-bg.png": 1062,
	"./pc/match/progress-title.png": 4727,
	"./pc/match/qrcode.jpg": 3564,
	"./pc/match/reward-brush-overlay.png": 7581,
	"./pc/match/reward-cash-prize-values.png": 5929,
	"./pc/match/reward-cash-prize.png": 5156,
	"./pc/match/reward-cash-title.png": 1256,
	"./pc/match/reward-character.png": 7628,
	"./pc/match/reward-command-award-label.png": 8597,
	"./pc/match/reward-individual-prize.png": 8356,
	"./pc/match/reward-individual-title.png": 493,
	"./pc/match/reward-kill-award-label.png": 6949,
	"./pc/match/reward-kill-award-label9.png": 8787,
	"./pc/match/reward-left-decoration.png": 1277,
	"./pc/match/reward-page-bg.jpg": 4350,
	"./pc/match/signup-entry-option-left-active.png": 1908,
	"./pc/match/signup-entry-option-left.png": 8295,
	"./pc/match/signup-entry-option-right-active.png": 3634,
	"./pc/match/signup-entry-option-right.png": 7210,
	"./pc/match/signup-flow-board.png": 3552,
	"./pc/match/signup-flow-character.png": 9747,
	"./pc/match/signup-flow-title.png": 2152,
	"./pc/match/signup-info-card-featured.png": 8833,
	"./pc/match/signup-mobile-entry-button-left.png": 9394,
	"./pc/match/signup-mobile-entry-button-right.png": 4893,
	"./pc/match/signup-mobile-flow-board.png": 1709,
	"./pc/match/signup-mobile-flow-character.png": 346,
	"./pc/match/signup-mobile-flow-title.png": 5207,
	"./pc/match/signup-mobile-info-title.png": 3305,
	"./pc/match/signup-mobile-page-bg.png": 3639,
	"./pc/match/signup-mobile-watch-card-2.png": 2252,
	"./pc/match/signup-mobile-watch-title.png": 9667,
	"./pc/match/signup-news-board.png": 8814,
	"./pc/match/signup-news-cover.png": 3733,
	"./pc/match/signup-news-title.png": 2989,
	"./pc/match/signup-page-bg.jpg": 5466,
	"./pc/match/signup-watch-title.png": 7138,
	"./pc/match/ss-1.png": 7619,
	"./pc/match/ss-2.png": 1831,
	"./pc/match/ss.png": 6853,
	"./pc/match/video-card-frame.png": 96,
	"./pc/match/video-cover.png": 2957,
	"./pc/match/video-section-bg.png": 4585,
	"./pc/match/video-title.png": 8816,
	"./pc/match/videoTitle.png": 3893,
	"./pc/match/zd1.png": 8055,
	"./pc/match/zd2.png": 1636
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2510;